
import React from "react";

const Main = props => {
    return (
        <>
            <div className="page-header theme-bg-dark py-5 text-center position-relative">
                <div className="theme-bg-shapes-right"></div>
                <div className="theme-bg-shapes-left"></div>
                <div className="container">
                    <h1 className="page-heading single-col-max mx-auto">We Enable Payments.</h1>
                    <div className="page-intro single-col-max mx-auto">Everything you need to get your software documentation online.
                    </div>
                    {/* <div className="main-search-box pt-3 d-block mx-auto">
                        <form className="search-form w-100">
                            <input type="text" placeholder="Search the docs..." name="search" className="form-control search-input"></input>
                            <button type="submit" className="btn search-btn" value="Search"><i className="fas fa-search"></i></button>
                        </form>
                    </div> */}
                </div>
            </div>
            <div className="page-content">
                <div className="container">
                    <div className="docs-overview py-5">
                        <div className="row justify-content-center">
                            <div className="col-12 col-lg-4 py-3">
                                <div className="card shadow-sm">
                                    <div className="card-body">
                                        <div className="card-title mb-3">
                                            <span className="theme-icon-holder card-icon-holder me-2">
                                                <img src="/assets/images/online.png" style={{ width: '80px', height: '80px' }}></img>
                                            </span>
                                            <span className="card-title-text">Online API Integration</span>
                                        </div>
                                        <div className="card-text">

                                        </div>
                                        <a className="card-link-mask" href="online-api"></a>
                                    </div>
                                </div>
                            </div>
                            <div className="col-12 col-lg-4 py-3">
                                <div className="card shadow-sm">
                                    <div className="card-body">
                                        <div className="card-title mb-3">
                                            <span className="theme-icon-holder card-icon-holder me-2">
                                                <img src="/assets/images/access.png" style={{ width: '80px', height: '80px' }}></img>
                                            </span>
                                            <span className="card-title-text">Access 2.0 API Integration</span>
                                        </div>
                                        <div className="card-text">

                                        </div>
                                        <a className="card-link-mask" href="access-v2"></a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Main;